import ApiClient from './ApiClient';

/* global axios */
class LocationsApi extends ApiClient {
  importCSV(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/import_csv`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export const storeLocationsApi = new LocationsApi('store_locations', {
  accountScoped: true,
});
export const maintenanceZonesApi = new LocationsApi('maintenance_zones', {
  accountScoped: true,
});
